<template>
    <main class="mt-5">
        <span id="add-btn">
            <button :disabled="hasPermission('write_store') ? false : true" @click="createItem" class="btn btn-success">
            انبار جدید</button>
        </span>
        <b-tooltip v-if="!hasPermission('write_store')" target="add-btn" triggers="hover">
        شما به این بخش دسترسی ندارید
        </b-tooltip>
        <FormModal :edit-model="edit" :mode="mode" @create="onCreate" @edit="onEdit" :url="url"
            :modal-name="$options.name" :create-rules="createRules" :edit-rules="editRules"></FormModal>
        <b-tooltip v-if="!hasPermission('write_store')" target="add-btn" triggers="hover">
            شما به این بخش دسترسی ندارید
        </b-tooltip>
        <div class="card mt-3">
            <div class="d-flex justify-content-center">  
                <div class="alert alert-warning justify-content-center align-items-center" style="width: 100%;">  
                    <span class="font-weight-bold text-danger">توجه:</span>  
                    <span class="mr-1">موجودی تمامی محصولات در زمان ثبت و ویرایش به انبار <span class="font-weight-bold">اصلی</span> منتقل میشوند.</span>  
                </div>  
            </div>
            <div class="card-header  border-0">
                <h5 class="card-title font-bold">لیست انبارها</h5>
                <div style="flex:1"></div>
            </div>
            <div class="card-body">
                <div>
                    <b-table v-if="items.length" responsive hover bordered :items="items" :fields="fields">
                        <template v-slot:cell(index)="data">
                            {{ data.index + 1}}
                        </template>
                        <template v-slot:cell(is_main)="data">
                            <span v-if="data.item.is_main" class="font-size-26 text-success fa fa-check-circle-o"></span>
                            <span v-else class="font-size-26 text-danger fa fa-times-circle-o"></span>
                        </template>
                        <template v-slot:cell(created_at)="data">
                            {{ data.item.created_at | persianDate}}
                        </template>
                        <template v-slot:cell(stores)="data">
                            <button   
                                class="btn btn-sm btn-dark"   
                                type="button"    
                                data-toggle="modal"   
                                :data-target="'#sort-stores-' + data.item.id">  
                                مشاهده  
                            </button>  
                        </template>
                        <template v-slot:cell(operation)="data">
                            <div class="d-flex align-items-center justify-content-center">
                                <span :id="'edit-btn-' + data.item.id">
                                    <a :disabled="!hasPermission('read_store') ? true : false " class="action-btns1 pt-1 px-1"  
                                    @click="editItem(data.index)">
                                    <i style="vertical-align: text-top" class="fe fe-edit text-warning"></i>  
                                    </a>
                                </span>
                                <b-tooltip v-if="!hasPermission('read_store')" :target="'edit-btn-' + data.item.id" triggers="hover">
                                    شما به این بخش دسترسی ندارید
                                </b-tooltip>

                                <span :id="'delete-btn-' + data.item.id">
                                    <a :disabled="!hasPermission('read_store') ? true : false " class="action-btns1 pt-1 px-1"
                                    @click="deleteItem(data.item.id)">
                                    <i style="vertical-align: text-top" class="feather feather-trash-2 text-danger"></i>
                                    </a>
                                </span>
                                <b-tooltip v-if="!hasPermission('read_store')" :target="'delete-btn-' + data.item.id" triggers="hover">
                                    شما به این بخش دسترسی ندارید
                                </b-tooltip>
                            </div>
                        </template>
                    </b-table>
                    <div v-else class="alert alert-danger">
                        موردی یافت نشد
                    </div>
                    <Loading v-if="$root.isEmptyObject(items)" />
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import StoresLmpl from '@@/core/pages/Store/Stores/StoresLmpl'
export default {
    extends: StoresLmpl
}
</script>
<style scoped>
.box-stores {  
    border: 0.3px solid black;  
    border-radius: 14px;  
    cursor: pointer;  
}  
.selected {  
    background-color: aqua !important;   
}  
</style>